import {load} from 'dataModulesLoader';
import {bootstrap} from './bootstrap';

load().done(() => bootstrap());
